/*
 * Filename: uiType-value-source.controller.ts
 * Description: Handling uiType value source rule
 */

import { CQMasterDataStore } from '../../../store/cq-master-data.store';

export class CQUITypeValueSourceController {
    public setUITypeSource = (templateName :string, uiTypeDetail :any) => {
        const selectedField: any = CQMasterDataStore.Details.selectedFieldDetailsObject;
        CQMasterDataStore.UITypeSource.addUITypeSource(selectedField.fullName, uiTypeDetail);
        CQMasterDataStore.OutputConfig.setuiType(templateName, CQMasterDataStore.UITypeSource.FieldUIType);
        CQMasterDataStore.OutputConfig.setRuleElements(templateName, CQMasterDataStore.RuleElements.FieldRuleElement);
    }
}